import { css, FlattenSimpleInterpolation, keyframes } from 'styled-components';

export const size = {
  smallPhone: 320,
  tablet: 768,
  desktop: 1025,
  largeDesktop: 1440,
};

const device = {
  smallPhone: `(max-width: ${size.smallPhone}px)`,
  tablet: `(min-width: ${size.tablet}px)`,
  desktop: `(min-width: ${size.desktop}px)`,
  largeDesktop: `(min-width: ${size.largeDesktop}px)`,
};

export const time = {
  transitions: {
    default: 300,
  },
  carousel: {
    transform: { default: 250 },
  },
  scroll: 1000,
  fade: {
    slow: 2000,
    medium: 1000,
    fast: 200,
  },
};

export const transitions = {
  default: `${time.transitions.default}ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
};

export const onSmallPhoneMediaQuery = (): string => `  
  @media ${device.smallPhone}
`;

export const onTabletMediaQuery = (): string => `  
  @media ${device.tablet}
`;

export const onDesktopMediaQuery = (): string => `  
  @media ${device.desktop}
`;

export const onLargeDesktopMediaQuery = (): string => `  
  @media ${device.largeDesktop}
`;

export const onLandscape = (): string => `
  @media (orientation: landscape)
`;

export const onPortrait = (): string => `
  @media (orientation: portrait)
`;

export const ScrollBar = css`
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: rgba(255, 255, 255, 0.1) rgba(0, 0, 0, 0);
  scrollbar-width: thin;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  &::-webkit-scrollbar {
    width: 6px;
    background: rgba(0, 0, 0, 0);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    -webkit-border-radius: 4px;
  }
`;

export const NoScrollBar = css`
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
`;

const fadeInFrames = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOutFrames = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const FadeIn = (time: number): FlattenSimpleInterpolation => css`
  animation: ${time}ms ${fadeInFrames} ease-out;
`;

export const FadeOut = (time: number): FlattenSimpleInterpolation => css`
  animation: ${time}ms ${fadeOutFrames} ease-in;
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/theme/utils.ts